export default __webpack_public_path__ + "static/media/laundry2-afterB-1440w.1a506e2d.png";